import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { isNotFoundError, R } from 'core/helpers'
import { useInternalBorrowerPaymentInstrumentGet } from 'core/types'

import ModelLink from './ModelLink'

type PaymentInstrumentLinkProps = {
  paymentInstrumentId: string
}

const PaymentInstrumentLink: FC<PaymentInstrumentLinkProps> = ({
  paymentInstrumentId,
}) => {
  const [_, { personId, companyId }] = useQueryApi()

  const { data: paymentInstrument, isLoading } =
    useInternalBorrowerPaymentInstrumentGet({
      companyId,
      personId,
      paymentInstrumentId,
      options: { throwOnError: R.isNot(isNotFoundError) },
    })

  return (
    <ModelLink
      id={paymentInstrumentId}
      isLoading={isLoading}
      link={`/companies/${companyId}/borrowers/${personId}/payment-instruments/${paymentInstrumentId}`}
      model={paymentInstrument}
    />
  )
}

export default PaymentInstrumentLink
